import { useEffect, useState } from 'react';
import { apiGet } from './api';

// Admin-managed Help Center: the non-CBSE contribution ask, the textbook-scan
// guidelines and the FAQs Study Buddy answers from. One fetch, cached.

let cache = null;
let inflight = null;

export async function fetchHelpCenter() {
  if (cache) return cache;
  if (!inflight) {
    inflight = apiGet('/public/settings')
      .then(d => { cache = d?.help_center || {}; return cache; })
      .catch(() => ({}))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useHelpCenter() {
  const [help, setHelp] = useState(cache || {});
  useEffect(() => { fetchHelpCenter().then(setHelp); }, []);
  return help;
}
